export default {

    PAGINATION: {
        page_count: 25
    }

}